import { useCallback } from 'react';
import api from '@/lib/api';
import useAddressesLogic from '@/shared/checkout/useAddressesLogic';

/**
 * Wrapper CRM de `useAddressesLogic` partilhado — apenas injecta o endpoint
 * `/api/encomendas/addresses`. Para retro-compat com o resto do código
 * antigo, expõe os campos legacy `selectedEnvio` / `selectedFatura`.
 */
export default function useAddresses() {
  const fetchAll = useCallback(async () => {
    const r = await api.post('/encomendas/addresses', {});
    return r.data?.data || [];
  }, []);

  const logic = useAddressesLogic({ fetchAll });

  // `reload(newId, target)` legacy signature → mapeia para o objecto.
  const reload = useCallback((selectId, target) => {
    if (selectId == null) return logic.reload();
    const t = target === 'envio' ? 'shipping' : target === 'fatura' ? 'billing' : null;
    return logic.reload({ selectId, target: t });
  }, [logic]);

  return {
    addresses: logic.addresses,
    billingAddresses: logic.billingAddresses,
    selectedEnvio: logic.selectedShipping,
    setSelectedEnvio: logic.setSelectedShipping,
    selectedFatura: logic.selectedBilling,
    setSelectedFatura: logic.setSelectedBilling,
    reload,
  };
}
